import UserActionsEnums from './UserActionsEnums'

const defaultState = {
    isLoaded: false,
    isLoading: false,
    userData: null
};

function UserReducer(state = defaultState, action) {
    switch (action.type) {
        case UserActionsEnums.USER_SET_BASIC_INFO:
            return {
                ...state,
                login: action.userData.login,
                userData: action.userData
            };
        case UserActionsEnums.USER_GET_INFO:
            return {
                ...state,
                isLoading: true
            };
        case UserActionsEnums.USER_GET_INFO_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                login: action.userData.login,
                userData: action.userData
            };
        case UserActionsEnums.USER_CLEAN:
            return {
                ...state,
                isLoaded: false,
                userData: null,
                login: null
            };
        default:
            return state;
    }
}

export default UserReducer;



// WEBPACK FOOTER //
// ./src/store/user/UserReducer.js